require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ru-pages-aircraft-cleaning.json") })
        }
      }, "path---ru-pages-aircraft-cleaning");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ru-pages-aircraft-cleaning!./.cache/json/ru-pages-aircraft-cleaning.json
// module id = 780
// module chunks = 231608221292675